var _circle, _path, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleAnimation = function SvgCircleAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    fill: "#004996",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "--animation-duration": "0.5s",
      transformOrigin: "12px 12px",
      animation: "nc-loop-circle-anim var(--animation-duration) infinite linear"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "none",
    opacity: 0.4,
    r: 11,
    stroke: "#004996",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1a11 11 0 0 1 11 11",
    "data-cap": "butt",
    "data-color": "color-2",
    fill: "none",
    stroke: "#004996",
    strokeWidth: 2,
    strokeLinecap: "butt"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n      @keyframes nc-loop-circle-anim{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n    "))));
};
export default SvgCircleAnimation;